import { render } from "./WineClubHeader.vue?vue&type=template&id=00610291&scoped=true"
import script from "./WineClubHeader.vue?vue&type=script&lang=js"
export * from "./WineClubHeader.vue?vue&type=script&lang=js"

import "./WineClubHeader.vue?vue&type=style&index=0&id=00610291&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00610291"]])

export default __exports__